import * as React from "react";
import {WithApi, WithApiProperties} from "../common/util/WithApi";
import {FormattedMessage} from "react-intl";
import {Row} from "react-bootstrap";
import {Spinner} from "../common/ui/spinner/Spinner";
import axios, {AxiosError} from "axios";
import {Redirect} from "react-router-dom";
import {ErrorDisplay} from "../common/ui/errordisplay/ErrorDisplay";

interface GeoprocessingPageState {
    loading: boolean;
    geoprocessingServer: string;
    geoprocessingServiceUrlValid: boolean;
    professionalLicense: boolean;
  error: AxiosError;
}

class GeoprocessingPageComponent extends React.Component<WithApiProperties, GeoprocessingPageState> {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            geoprocessingServer: null,
            geoprocessingServiceUrlValid: null,
          professionalLicense: null,
          error: null,
        };
    }

    componentDidMount() {
        this.props.api.getGeoprocessingServiceSettings()
            .then((geoprocessingServiceSettings) => {
              this.setState({geoprocessingServer: geoprocessingServiceSettings.geoprocessingServerUrl});
                Promise.allSettled([
                  this.props.api.isGeoprocessingServiceUrlValid(geoprocessingServiceSettings.geoprocessingServerUrl),
                    axios.get('../actuators/health/license')
                ]).then((response) => {
                    let geoprocessingServiceUrlValid = false;
                    let professionalLicense = false;
                    if (response[0].status === 'fulfilled') {
                        geoprocessingServiceUrlValid = true;
                    }
                    if (response[1].status === 'fulfilled') {
                        const licenseResponse = response[1] as PromiseFulfilledResult<any>;
                      if (licenseResponse.value.status === 200 && licenseResponse.value.data?.status === "UP" &&
                          licenseResponse.value.data?.details.feature) {
                            professionalLicense = licenseResponse.value.data.details.feature === "approf";
                        }
                    }

                    this.setState({
                        geoprocessingServiceUrlValid,
                        professionalLicense,
                        loading: false
                    });
                })
                    .catch((error) => {
                      this.setState({error});
                    })
            })
            .catch((error) => {
              this.setState({error});
            })
    }

    render() {
        return (<div style={{width: "100%", height: "100%"}}> {this.renderContent()}</div>);
    }

    private renderContent() {
      const {geoprocessingServer, loading, geoprocessingServiceUrlValid, professionalLicense, error} = this.state;

      if (error) {
        if (error?.response.status === 401) {
          return <Redirect to="/login"/>;
        }
        return <ErrorDisplay error={error}/>;
      }

        if (loading) {
            return GeoprocessingPageComponent.renderLoading();
        }

        if (geoprocessingServer != null) {
            if (!professionalLicense || !geoprocessingServiceUrlValid) {
                return this.renderError();
            } else {
                return (
                    <iframe width="100%" height="100%" frameBorder="0" src={geoprocessingServer}/>
                );
            }
        }
        return null;
    }

    private static renderLoading() {
        return (
            <Row style={{textAlign: "center"}}>
                <h2>
                    <FormattedMessage id="studio.settings.geoprocessing-service.loading"
                                      defaultMessage="Loading..."/>
                </h2>
                <Spinner bigStyle/>
            </Row>
        );
    }


    private renderError() {
        const {professionalLicense, geoprocessingServer} = this.state;

        if (!professionalLicense) {
            return (
                <div>
                    <div>
                        <strong>
                            <FormattedMessage id="studio.settings.geoprocessing-service.not-professional"
                                              defaultMessage="ERDAS APOLLO Professional License is required for Geoprocessing."/>
                        </strong>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div>
                        <strong>
                            <FormattedMessage id="studio.settings.geoprocessing-service.not-found"
                                              defaultMessage="ERDAS APOLLO Geoprocessing endpoint URL is not valid. Please check configuration."/>
                        </strong>
                        <br/><br/>
                        <FormattedMessage id="studio.settings.geoprocessing-service.current"
                                          defaultMessage="Current Geoprocessing Engine base URL is: "/>
                        {geoprocessingServer}
                    </div>
                </div>
            );
        }
    }
}

export const GeoprocessingPage = WithApi(GeoprocessingPageComponent);